import { render } from "./Fornecedores.vue?vue&type=template&id=30fc3394&scoped=true"
import script from "./Fornecedores.vue?vue&type=script&lang=js"
export * from "./Fornecedores.vue?vue&type=script&lang=js"

import "./Fornecedores.vue?vue&type=style&index=0&id=30fc3394&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fc3394"]])

export default __exports__